import { useDispatch, useSelector, useStore } from "react-redux";
import {
	exportStats as exportStatsAction,
	getBoxScore as getBoxScoreAction
} from "./actions";

const useStatsContext = () => {
	const dispatch = useDispatch();
	const store = useStore();

	const useJsonStats = () => useSelector((state) => state.stats.jsonStats);
	const useBoxScore = () => useSelector((state) => state.stats.boxScore);

	const exportStats = () => {
		const { game } = store.getState().game;
		if (game) {
			exportStatsAction(game.id, dispatch);
		}
	};

	const getBoxScore = () => {
		const { game } = store.getState().game;
		if (game) {
			getBoxScoreAction(game.id, dispatch);
		}
	};

	const state = {
		jsonStats: useJsonStats,
		boxScore: useBoxScore
	};

	return {
		state,
		exportStats,
		getBoxScore
	};
};

export { useStatsContext };
